import { IEaivMembershipStatistics } from './types';

import { DateTimeFormat } from '../../lib/date';

export const getDefaultEaivMembershipStatistics = (): IEaivMembershipStatistics => ({
  verificationAttempts: {
    ageSubmitSuccess: 0,
    ageSubmitFailed: 0,
    ageSubmitErrorReasons: [],
    identityStartSuccess: 0,
    identityStartFailed: 0,
    identityStartErrorReasons: [],
    identitySubmitSuccess: 0,
    identitySubmitFailed: 0,
    identitySubmitErrorReasons: [],
  },
});

export const EAIV_ERROR_REASON_TIMESTAMP_FORMAT = DateTimeFormat.DateTime12h;

export const EAIV_ERROR_REASON_DEFAULT_MESSAGE = 'Unknown reason';
